import React from 'react';
import { Building2, Users, Briefcase, GraduationCap, Heart, Home, Palette, TrendingUp } from 'lucide-react';

export const TrustedBy = () => {
  const industries = [
    { name: 'Tech', icon: TrendingUp },
    { name: 'Design', icon: Palette },
    { name: 'Marketing', icon: Briefcase },
    { name: 'Consulting', icon: Building2 },
    { name: 'Real Estate', icon: Home },
    { name: 'Healthcare', icon: Heart },
    { name: 'Education', icon: GraduationCap },
    { name: 'Enterprise', icon: Users },
  ];

  return (
    <section className="py-12 px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <p className="text-center text-gray-700 font-bold text-lg mb-8">
          Trusted by professionals, creators, and teams in 40+ industries
        </p>
        
        <div className="flex items-center justify-center flex-wrap gap-4">
          {industries.map((industry, index) => {
            const Icon = industry.icon;
            return (
              <div 
                key={index}
                className="bg-white rounded-2xl px-6 py-3 shadow-sm hover:shadow-md transition-all duration-300 flex items-center gap-2"
              >
                <Icon className="w-5 h-5 text-navy" />
                <span className="font-semibold text-navy">{industry.name}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
